import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { ArchiveFileSyncRule } from '../models/archive/archive-file-sync-rule.model';

@Injectable({
  providedIn: 'root',
})
export class ArchiveFileSyncRuleService extends RequestService<ArchiveFileSyncRule> {
  static PATH = '/archive/file/sync/rule';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ArchiveFileSyncRuleService.PATH, globalService.debugUrl);
  }
}
